export const SITE_URL = "https://emeraedu.com.br";
export const SITE_NAME = "Emera";
export const COMMUNITY_URL = "https://chat.whatsapp.com/GUF5HfehUSDBTucCa3rh2v";
